<template>
    <Form class="form p-4">
        <div class="grid grid-nogutter gap-4 mb-4">
            <div class="col-12 md:col-3 flex flex-column justify-content-start gap-1">
                <span class="Label">Profile details</span>
                <span class="Caption">View & update profile details</span>
            </div>
            <div class="col-12 md:col-6 flex flex-column gap-3">
                <label for="Name" class="Label align-self-start">Name</label>
                <IconField class="w-full">
                    <InputIcon class="pi pi-user" />
                    <InputText placeholder="Enter name here" size="small" variant="filled" class="w-full"
                        v-model="form.userName" />
                </IconField>
                <small v-if="errors.username" class="p-error">{{ errors.username }}</small>
                <label for="email" class="Label align-self-start">Email</label>
                <IconField class="w-full">
                    <InputIcon class="pi pi-envelope" />
                    <InputText placeholder="Enter email here" size="small" variant="filled" class="w-full"
                        v-model="form.email" />
                </IconField>
                <small v-if="errors.email" class="p-error">{{ errors.email }}</small>
            </div>
        </div>
        <Divider class="w-full py-2" />
        <div class="grid grid-nogutter gap-4 mb-4">
            <div class="col-12 md:col-3 flex flex-column justify-content-start gap-1">
                <span class="Label">Profile security</span>
                <span class="Caption">View & update profile security</span>
            </div>
            <div class="col-12 md:col-6 flex flex-column gap-3">
                <label for="currentPassword" class="Label align-self-start mb-2">Current password</label>
                <IconField class="w-full">
                    <InputIcon class="pi pi-lock" />
                    <Password v-model="form.currentPassword" toggleMask placeholder="Current password" size="small"
                        variant="filled" class="w-full" autocomplete="current-password" :feedback="false"
                        :class="{ 'p-invalid': errors.currentPassword }" />

                </IconField>
                <small v-if="errors.currentPassword" class="p-error">{{ errors.currentPassword }}</small>
                <label for="newPassword" class="Label align-self-start mb-2">New password</label>
                <IconField class="w-full">
                    <InputIcon class="pi pi-lock" />
                    <Password v-model="form.newPassword" toggleMask placeholder="New password" size="small"
                        variant="filled" class="w-full" autocomplete="new-password" :feedback="false"
                        :class="{ 'p-invalid': errors.newPassword }" />

                </IconField>
                <small v-if="errors.newPassword" class="p-error">{{ errors.newPassword }}</small>
                <label for="confirmPassword" class="Label align-self-start mb-2">Confirm password</label>
                <IconField class="w-full">
                    <InputIcon class="pi pi-lock" />
                    <Password v-model="form.confirmPassword" toggleMask placeholder="Confirm password" size="small"
                        variant="filled" class="w-full" autocomplete="new-password" :feedback="false"
                        :class="{ 'p-invalid': errors.confirmPassword }" />
                </IconField>
                <small v-if="errors.confirmPassword" class="p-error">{{ errors.confirmPassword }}</small>
            </div>
        </div>
        <div class="flex justify-content-end gap-4 mt-6">
            <Button label="Update" class="accent-button" @click="update" />
            <Button label="Cancel" class="accent-button-transparent" @click="cancel" />
        </div>
    </Form>
</template>
<script setup>
import { Form } from "@primevue/forms";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Password from 'primevue/password';
import Divider from "primevue/divider";
import { defineProps, watch, ref, defineEmits } from "vue"

const props = defineProps({
    user: null
})
const emit = defineEmits("update-profile")
const form = ref({
    userName: "",
    email: "",
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
});
const errors = ref({
    username: '',
    email: '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
})

const validateForm = () => {
    errors.value = {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
        username: '',
        email: '',
    };

    let isValid = true;

    if (!form.value.userName) {
        errors.value.username = 'User Name is required.';
        isValid = false;
    }

    if (!form.value.email) {
        errors.value.email = 'Email is required.';
        isValid = false;
    }

    const hasAnyPasswordField =
        form.value.currentPassword ||
        form.value.newPassword ||
        form.value.confirmPassword;

    if (hasAnyPasswordField) {
        if (!form.value.currentPassword) {
            errors.value.currentPassword = 'Current password is required.';
            isValid = false;
        }
        if (!form.value.newPassword) {
            errors.value.newPassword = 'New password is required.';
            isValid = false;
        }
        if (!form.value.confirmPassword) {
            errors.value.confirmPassword = 'Confirm password is required.';
            isValid = false;
        }

        if (
            form.value.newPassword &&
            form.value.confirmPassword &&
            form.value.newPassword !== form.value.confirmPassword
        ) {
            errors.value.confirmPassword = 'Passwords do not match.';
            isValid = false;
        }
    }

    return isValid;
};
watch(
    () => props.user,
    (newUser) => {
        if (newUser) {
            form.value.userName = newUser.username || "";
            form.value.email = newUser.email || "";
        }
    },
    { immediate: true }
);

const update = () => {
    if (!validateForm()) {
        return;
    }
    emit("update-profile", form.value)
};

const cancel = () => {
    
};
</script>
<style scoped>
.p-error {
    color: red;
}

.form {
    width: 100%;
    background-color: white;
}

@media (max-width: 768px) {
    .form {
        min-width: none;
    }
}
</style>